let mainPath = "/tailors";
let viewFolder = "Tailor";

module.exports = [
    {
        path: mainPath,
        name: 'tailors',
        component: () => import(/* webpackChunkName: "Warehouse" */ '../views/'+viewFolder+'/Index.vue'),
        // beforeEnter: (to, from, next) => {
        //   if (!localStorage.getItem('userId')) next({ name: 'Home' })
        //   else next()
        // }
    }
]